import "./svg/nav-cart-filled.svg"

export default {
    name: "nav-cart-filled",
    viewBox: "25 25",
}
